import * as amplitude from '@amplitude/analytics-browser';

interface SearchParams {
    destinationPlaceId: string;
    destinationText: string;
    originPlaceId: string;
    originText: string;
}

interface FilterEventProps {
    searchParams?: SearchParams | Record<string, string>;
    filterType: string;
    modeType?: string;
}

function filterCollapsed({
    filterType,
    modeType,
    searchParams = {},
}: FilterEventProps) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    amplitude.track('search_interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        collapsed_filter: filterType,
        depart_address: originText,
        depart_place_id: originPlaceId,
        interaction_type: 'filter_collapsed',
        mode_type: modeType,
    });
}

function filterExpanded({
    filterType,
    modeType,
    searchParams = {},
}: FilterEventProps) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    amplitude.track('search_interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        expanded_filter: filterType,
        interaction_type: 'filter_expanded',
        mode_type: modeType,
    });
}

function filterListCollapsed({
    filterType,
    searchParams = {},
}: FilterEventProps) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    amplitude.track('search_interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        collapsed_filter_list: filterType,
        depart_address: originText,
        depart_place_id: originPlaceId,
        interaction_type: 'filter_list_collapsed',
    });
}

function filterListExpanded({
    filterType,
    searchParams = {},
}: FilterEventProps) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    amplitude.track('search_interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        expanded_filter_list: filterType,
        interaction_type: 'filter_list_expanded',
    });
}

function singleFilterReset({
    filterType,
    searchParams = {},
}: FilterEventProps) {
    const {
        destinationPlaceId,
        destinationText,
        originPlaceId,
        originText,
    } = searchParams;

    amplitude.track('search_interacted', {
        arrive_address: destinationText,
        arrive_place_id: destinationPlaceId,
        depart_address: originText,
        depart_place_id: originPlaceId,
        interaction_type: 'single_filter_reset',
        reset_filter: filterType,
    });
}

export default {
    filterCollapsed,
    filterExpanded,
    filterListCollapsed,
    filterListExpanded,
    singleFilterReset,
};
